<!-- @format -->

<template>
  <div class="index">
    <div :class="yishengyice ? 'banner-ysyc' : 'banner'"></div>

    <div class="application">
      <div class="appbox">
        <div class="boxcon" @mouseenter="changeImageSrc('hover')" @mouseleave="changeImageSrc('nohover')" @click="modal1 = true">
          <img style="height: 58px; width: 58px" :src="imgsrc" alt="" />
          <div class="righttext">
            <p ref="image" class="righttextp">学生求职</p>
            <p ref="imagee" class="righttextb">一键职达数十万岗位</p>
          </div>
        </div>

        <div class="boxcon" @mouseenter="changeImageSrc2('hover')" @mouseleave="changeImageSrc2('nohover')" @click="goqiye">
          <img style="height: 58px; width: 58px" :src="imgsrc2" alt="" />
          <div class="righttext">
            <p ref="image2" class="righttextp">企业招聘</p>
            <p ref="imagee2" class="righttextb">一号招揽千余高校人才</p>
          </div>
        </div>

        <div class="boxcon" @mouseenter="changeImageSrc3('hover')" @mouseleave="changeImageSrc3('nohover')" @click="gogaoxiao">
          <img style="height: 58px; width: 58px" :src="imgsrc3" alt="" />
          <div class="righttext">
            <p ref="image3" class="righttextp">高校管理</p>
            <p ref="imagee3" class="righttextb">一生一策精准就业数据</p>
            <!-- <p ref="imagee3" class="righttextb">让求职不再迷茫</p> -->
          </div>
        </div>
      </div>
    </div>

    <div class="img1">
      <div class="imgbox">
        <img style="height: 370px; width: 579px" src="@/assets/jingzhun.png" alt="" />
        <div style="margin-left: 100px">
          <div style="display: flex; margin-bottom: 40px">
            <p class="text1">更精准</p>
            <img style="height: 17px; width: 17px; margin-left: 10px" src="@/assets/dianzhui.png" alt="" />
          </div>

          <p class="text2">一生一策精准就业数据</p>
          <p class="text3">高校实时了解上百个就业市场和</p>
          <p class="text3">求职行为大数据指标分析</p>
        </div>
      </div>
    </div>

    <div class="img2">
      <div class="imgbox2">
        <div style="margin: 0 135px 0 20px">
          <div style="display: flex; margin-bottom: 40px">
            <p class="text1">更简单</p>
            <img style="height: 17px; width: 17px; margin-left: 10px" src="@/assets/dianzhui.png" alt="" />
          </div>

          <p class="text2">一号招揽千余高校人才</p>
          <p class="text3">企业在线触达全球五十万人才</p>
          <p class="text3">轻松在线筛选简历</p>
        </div>
        <img style="height: 459px; width: 572px" src="@/assets/jiandan.png" alt="" />
      </div>
    </div>

    <div class="img3">
      <div class="imgbox">
        <img style="height: 450px; width: 439px" src="@/assets/zhineng.png" alt="" />
        <div style="margin-left: 285px">
          <div style="display: flex; margin-bottom: 40px">
            <p class="text1">更智能</p>
            <img style="height: 17px; width: 17px; margin-left: 10px" src="@/assets/dianzhui.png" alt="" />
          </div>

          <p class="text2">一键职达数十万岗位</p>
          <p class="text3">学生个性化智能匹配意向岗位</p>
          <p class="text3">让求职不再迷茫</p>
        </div>
      </div>
    </div>

    <div class="boter">
      <div class="boterbox">
        <div class="boxbit">
          <img style="height: 50px; width: 50px; margin-right: 20px" src="@/assets/duo.png" alt="" />

          <div class="boterright">
            <div class="righttextcon">
              <p>多</p>
              <div class="bitxian"></div>
              <p>500000+</p>
            </div>
            <p class="righttextconbot">求职学生质量保障</p>
          </div>
        </div>

        <div class="boxbit">
          <img style="height: 50px; width: 50px; margin-right: 20px" src="@/assets/quan.png" alt="" />

          <div class="boterright">
            <div class="righttextcon">
              <p>全</p>
              <div class="bitxian"></div>
              <p>20000+</p>
            </div>
            <p class="righttextconbot">在招企业门类齐全</p>
          </div>
        </div>

        <div class="boxbit">
          <img style="height: 50px; width: 50px; margin-right: 20px" src="@/assets/guang.png" alt="" />

          <div class="boterright">
            <div class="righttextcon">
              <p>广</p>
              <div class="bitxian"></div>
              <p>1000+</p>
            </div>
            <p class="righttextconbot">合作高校遍布全球</p>
          </div>
        </div>

        <div class="boxbit">
          <img style="height: 50px; width: 50px; margin-right: 20px" src="@/assets/zhi.png" alt="" />

          <div class="boterright">
            <div class="righttextcon">
              <p>智</p>
              <div class="bitxian"></div>
              <p>1+X</p>
            </div>
            <p class="righttextconbot">智能助力效率更高</p>
          </div>
        </div>
      </div>
    </div>

    <div class="modelcon">
      <Modal class-name="modelcon" v-model="modal1" :closable="false" width="290">
        <img v-if="yishengyice" style="height: 234px; width: 234px" src="@/assets/erweima2_ysyc.png" alt="" />
        <img v-else style="height: 234px; width: 234px" src="@/assets/erweima2.png" alt="" />
        <p class="allpoi">更多职位，请用微信扫码访问</p>

        <img class="closesty" @click="closemodel" src="@/assets/close.png" alt="" />

        <div slot="footer" class="footmod" @click="changedetail">
          <p>完善简历</p>
        </div>
      </Modal>
    </div>
  </div>
</template>

<script>
import Cookies from 'js-cookie'
import { get_detail } from '@/api/request.js'
export default {
  name: 'Index',
  data() {
    return {
      yishengyice: false,

      imgsrc: require('@/assets/xusheng_nor.png'),
      imgsrc2: require('@/assets/qiye_nor.png'),
      imgsrc3: require('@/assets/gaoxiao_nor.png'),

      modal1: false
    }
  },

  created() {
    this.yishengyice = sessionStorage.getItem('yishengyice') === '1'
  },

  methods: {
    changedetail() {
      if (Cookies.get('user_id')) {
        let data2 = {
          user_id: Cookies.get('user_id')
        }

        get_detail(data2).then(res => {
          if (res.apiStatus) {
            if (res.name) {
              sessionStorage.setItem('resume_data', JSON.stringify(res))
              this.$router.push({ path: '/resume' })
            } else {
              this.$router.push({ path: '/resume_create' })
            }
          }
        })
      } else {
        this.$router.push({
          path: '/login'
        })
      }
      this.modal1 = false
    },

    goqiye() {
      window.open('https://qiye.biyeshen.cn')
    },

    gogaoxiao() {
      window.open('https://gaoxiao.biyeshen.cn')
    },

    closemodel() {
      this.modal1 = false
    },
    changeImageSrc(key) {
      switch (key) {
        case 'hover':
          this.imgsrc = require('@/assets/xusheng_sel.png')
          this.$refs.image.style.color = '#fff'
          this.$refs.imagee.style.color = '#fff'
          break
        case 'nohover':
          this.imgsrc = require('@/assets/xusheng_nor.png')
          this.$refs.image.style.color = '#333'
          this.$refs.imagee.style.color = '#666'
          break
      }
    },

    changeImageSrc2(key) {
      switch (key) {
        case 'hover':
          this.imgsrc2 = require('@/assets/qiye_sel.png')
          this.$refs.image2.style.color = '#fff'
          this.$refs.imagee2.style.color = '#fff'
          break
        case 'nohover':
          this.imgsrc2 = require('@/assets/qiye_nor.png')
          this.$refs.image2.style.color = '#333'
          this.$refs.imagee2.style.color = '#666'
          break
      }
    },

    changeImageSrc3(key) {
      switch (key) {
        case 'hover':
          this.imgsrc3 = require('@/assets/gaoxiao_sel.png')
          this.$refs.image3.style.color = '#fff'
          this.$refs.imagee3.style.color = '#fff'
          break
        case 'nohover':
          this.imgsrc3 = require('@/assets/gaoxiao_nor.png')
          this.$refs.image3.style.color = '#333'
          this.$refs.imagee3.style.color = '#666'
          break
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.banner {
  height: 370px;
  width: 100%;
  background: url(../assets/image/banner.png) no-repeat center center;
  background-size: cover;
}
.banner-ysyc {
  height: 370px;
  width: 100%;
  background: url(../assets/image/banner-ysyc.png) no-repeat center center;
  background-size: cover;
}

.application {
  height: 256px;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #f2f7ff;
}

.appbox {
  width: 1000px;
  height: 136px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.boxcon {
  height: 136px;
  width: 300px;
  background: #ffffff;
  border-radius: 8px;
  border: 2px solid #3b80fb;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}

.boxcon:hover {
  color: #fff;
  background: #3b80fb;
  box-shadow: 0px 3px 10px 0px rgba(33, 93, 200, 0.67);
  border-radius: 8px;
  transition: all 0.8s;
}

.righttext {
  margin-left: 20px;
  display: flex;
  flex-direction: column;
  /* align-items: center; */
}

.righttextp {
  font-size: 24px;
  font-family: MicrosoftYaHei;
  color: #333;
}
/*
.gobox {
  width: 80px;
  height: 26px;
  font-size: 14px;
  font-family: MicrosoftYaHei;
  color: #666666;
  text-align: center;
  line-height: 26px;
  border-radius: 13px;
  border: 1px solid #cccccc;
} */

.righttextb {
  font-size: 14px;
  font-family: MicrosoftYaHei;
  color: #666666;
}

.img1 {
  height: 620px;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #fff;
}

.img2 {
  height: 620px;
  width: 100%;
  /* margin-left:20px; */
  display: flex;
  justify-content: center;
  align-items: flex-end;
  background: #f2f7ff;
}

.img3 {
  height: 620px;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #fff;
}

.imgbox {
  height: 370px;
  width: 1050px;
  /* position: relative; */
  display: flex;
  align-items: center;
}

.imgbox2 {
  height: 460px;
  width: 1050px;
  display: flex;
  align-items: flex-start;
}

.text1 {
  font-size: 28px;
  font-family: MicrosoftYaHei;
  color: #3b80fb;
}

.text2 {
  font-size: 32px;
  font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;
  font-weight: bold;
  color: #333333;
}

.text3 {
  font-size: 24px;
  font-family: MicrosoftYaHei;
  color: #666666;
}

.boter {
  height: 265px;
  width: 100%;
  background: #f8faff;
}

.boterbox {
  width: 1200px;
  height: 265px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: space-around;
}

.boxbit {
  width: 225px;
  height: 50px;
  display: flex;
  align-items: center;
}

.bitxian {
  width: 1px;
  height: 17px;
  border-right: 1px solid #ccc;
  margin: 0 10px;
}

.righttextcon {
  display: flex;
  align-items: center;
  font-size: 24px;
  font-family: MicrosoftYaHei;
  color: #333333;
}

.righttextconbot {
  font-size: 16px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #666666;
}

.allpoi {
  font-size: 16px;
  font-family: MicrosoftYaHei;
  color: #ffffff;
  margin-top: 20px;
}

.footmod {
  /* background:pink; */
  cursor: pointer;
  height: 38px;
  width: 234px;
  margin: 0 auto;
  color: #3b80fb;
  border-radius: 4px;
  border: 1px solid #3b80fb;
  /* height: 40px;*/
  line-height: 36px;
  text-align: center;
}

.footmod:hover {
  background: #ecf3ff;
}

.footmodp {
  font-size: 12px;
  font-family: MicrosoftYaHei;
  color: #666666;
  cursor: pointer;
  text-decoration: underline;
}

.closesty {
  height: 45px;
  width: 24px;
  position: absolute;
  top: -34px;
  right: 0;
  z-index: -1;
  cursor: pointer;
}
</style>

<style>
.modelcon .ivu-modal-body {
  background: #3b80fb;
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 318px;

  border-radius: 6px 6px 0px 0px;
  /* border-radius: 6px 6px 6px 6px; */
}

/* .ivu-modal-footer {
  padding: 0 !important;
  border: 0 !important;
} */

.modelcon .vertical-center-modal {
  display: flex;
  align-items: center;
  justify-content: center;
}
/* .ivu-modal {
  top: 0;
} */
</style>



// WEBPACK FOOTER //
// src/components/index.vue